import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, TrendingUp, MapPin, Award, DollarSign } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function AgentNetworkPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="pt-32 pb-20 px-4 md:px-8 bg-gradient-to-br from-orange-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <Users className="w-16 h-16 text-orange-600 mx-auto mb-6" />
          <h1 className="text-5xl md:text-7xl font-bold font-heading text-slate-900 mb-6">
            Britedge Agent Network
          </h1>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Earn up to ₦500,000 monthly as a Britedge agent. Help your community access financial services while building your own business.
          </p>
        </div>
      </section>

      <section className="py-20 px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold font-heading text-slate-900 mb-12 text-center">Earnings Breakdown</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { service: 'Account Opening', commission: '₦500 per account', volume: '20-50/month' },
              { service: 'Cash Deposits', commission: '0.5% per transaction', volume: '₦5M+/month' },
              { service: 'Bill Payments', commission: '₦50-200 per transaction', volume: '100+/month' },
              { service: 'POS Transactions', commission: '0.25% per transaction', volume: '₦10M+/month' },
              { service: 'Loan Referrals', commission: '2% of loan amount', volume: '5-10/month' },
              { service: 'Airtime/Data', commission: '3% commission', volume: '200+/month' }
            ].map((earning, idx) => (
              <div key={idx} className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200">
                <h3 className="text-lg font-bold text-slate-900 mb-4">{earning.service}</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-slate-600">Commission</span>
                    <span className="font-bold text-brand-blue">{earning.commission}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-slate-600">Avg. Volume</span>
                    <span className="font-semibold">{earning.volume}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 px-4 md:px-8 bg-gradient-to-br from-green-600 to-green-700 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <DollarSign className="w-16 h-16 mx-auto mb-6" />
          <h2 className="text-4xl font-bold font-heading mb-6">Start Earning Today</h2>
          <p className="text-xl text-green-100 mb-8">
            Requirements: Valid ID, Business location, ₦50,000 float capital
          </p>
          <Button 
            onClick={() => navigate('/contact')}
            className="bg-white text-green-600 hover:bg-green-50 rounded-full px-10 py-6 text-lg font-semibold"
          >
            Apply to Become an Agent
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
